import pomUpdates from 'ub_legacy/lp/pom/updates/updates';
import MigratorUtils from 'ub/fonts/pom-updater/migrator-utils';
import ubBanzai from 'ub/control/banzai-features';

const checkVersion = (jso, minVersion, newVersion) => {
  const current = jso.version || '0';

  if (current >= newVersion) {
    return false;
  }

  if (current < minVersion) {
    throw new Error(`Page version ${current} can't be updated to version ${newVersion}`);
  }
  return true;
};

pomUpdates.add({
  minVersion: '3.0',
  version: '3.1',
  run: function(originalData) {
    const canUpdate = checkVersion(originalData.mainPage, this.minVersion, this.version);

    if (canUpdate && ubBanzai.features.isRunFontStorageUpgraderEnabled()) {
      const newPagesData = MigratorUtils.migrateFonts(originalData);

      newPagesData.mainPage.version = this.version;
      newPagesData.subPages.forEach((page) => {
        page.version = this.version;
      });

      return newPagesData;
    } else {
      return originalData;
    }
  }
});



// WEBPACK FOOTER //
// ./src/updaters/3.1.js